import { createClient } from '@supabase/supabase-js';

// CRA expone REACT_APP_*, pero se aceptan también los nombres VITE_*
// para compartir el mismo archivo .env con el panel CRUD.
const url = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;
export const isSupabaseConfigured = Boolean(url && key);
export const supabase = createClient(url || 'https://placeholder.supabase.co', key || 'placeholder-key');
export const imageUrl = (value) => {
  if (!value) return '';
  if (String(value).startsWith('http')) return String(value);
  return supabase.storage.from(process.env.REACT_APP_SUPABASE_BUCKET || process.env.VITE_SUPABASE_BUCKET || 'productos').getPublicUrl(String(value)).data.publicUrl;
};
